import { render, staticRenderFns } from "./DocumentosEdicao.vue?vue&type=template&id=67625b25&scoped=true"
import script from "./DocumentosEdicao.vue?vue&type=script&lang=js"
export * from "./DocumentosEdicao.vue?vue&type=script&lang=js"
import style0 from "./DocumentosEdicao.vue?vue&type=style&index=0&id=67625b25&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67625b25",
  null
  
)

export default component.exports